interface TimeStringOptions {
  showZeros?: boolean; // Mostrar componentes aunque sean 0
  shortFormat?: boolean; // Usar formato corto (h, m, s)
}

export function convertSecondsToTimeString(
  seconds: number,
  options: TimeStringOptions = {}
): string {
  if (seconds === null || seconds === undefined) return '';
  if (isNaN(seconds)) return 'Tiempo inválido';

  seconds = Math.abs(Math.floor(seconds));

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const parts: string[] = [];

  const pluralize = (
    value: number,
    singular: string,
    plural: string
  ): string => {
    if (options.shortFormat) {
      return `${value}${singular.charAt(0)}`;
    }
    return `${value} ${value === 1 ? singular : plural}`;
  };

  if (days > 0 || (options.showZeros && options.shortFormat)) {
    parts.push(pluralize(days, 'día', 'días'));
  }

  if (hours > 0 || (options.showZeros && (options.shortFormat || days > 0))) {
    parts.push(pluralize(hours, 'hora', 'horas'));
  }

  if (
    minutes > 0 ||
    (options.showZeros && (options.shortFormat || hours > 0 || days > 0))
  ) {
    parts.push(pluralize(minutes, 'minuto', 'minutos'));
  }

  if (remainingSeconds > 0 || options.showZeros || parts.length === 0) {
    parts.push(pluralize(remainingSeconds, 'segundo', 'segundos'));
  }

  return parts.join(' ');
}
